<template>
    <div :class="loaderClass">
        <common-logo-spinner v-if="isProcessing" :width="width" :color="color"></common-logo-spinner>
    </div>
</template>

<script>
    export default {
        props: {
            isProcessing: { type: Boolean, default: false },
            // 36 px fits buttons and fields; pass 56 or 88 for dialogs and cards.
            width: { type: Number, default: 36 },
            // One colour, for example '#fff' on a coloured button. Empty keeps the blue to green gradient.
            color: { type: String, default: '' },
        },

        computed: {
            loaderClass() {
                return {
                    loader: true,
                    'loader--is-processing': this.isProcessing,
                }
            },
        },
    }
</script>
